import request from '@/utils/request'

// 查询森林地区列表
export function listForestArea(query) {
  return request({
    url: '/admin/forest/area/list',
    method: 'get',
    params: query
  })
}

// 查询森林地区详细
export function getForestArea(areaId) {
  return request({
    url: '/admin/forest/area/getInfo?areaId=' + areaId,
    method: 'get'
  })
}

// 新增森林地区
export function addForestArea(data) {
  return request({
    url: '/admin/forest/area',
    method: 'post',
    data: data
  })
}

// 修改森林地区
export function updateForestArea(data) {
  return request({
    url: '/admin/forest/area',
    method: 'put',
    data: data
  })
}

// 删除森林地区
export function delForestArea(areaId) {
  return request({
    url: '/admin/forest/area/deleteArea?areaId=' + areaId,
    method: 'delete'
  })
}
